import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconOnlineMeetings = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 626.1 430.2" {...props}>
      <path stroke="#c2d2da" strokeWidth="4" fill="#fff" d="M97.1 1.9H564v316.3H97.1z" />
      <path
        fill="#c2d2da"
        d="M117.8 13.2a3.8 3.8 0 0 1 3.8 3.7 3.8 3.8 0 0 1-3.8 3.8A3.8 3.8 0 0 1 114 17a3.8 3.8 0 0 1 3.8-3.7zM132.8 13.2a3.8 3.8 0 0 1 3.8 3.7 3.8 3.8 0 0 1-3.7 3.8A3.8 3.8 0 0 1 129 17a3.8 3.8 0 0 1 3.8-3.7zM148 13.2a3.8 3.8 0 0 1 3.7 3.7 3.8 3.8 0 0 1-3.8 3.8 3.8 3.8 0 0 1-3.8-3.8 3.8 3.8 0 0 1 3.8-3.7z"
      />
      <path fill="#e5ebed" d="M99 30.1h463.1v286.2H99z" />
      <g fill="#c2d2da" opacity=".3">
        <path d="M241.1 59.5H548v203.3H241.1z" />
        <path d="M123.8 100.6v53.5h68.4v-44.8H156l-11-8.7h-21.2z" />
      </g>
      <g fill="#fff" stroke={theme.colors.fountainBlue} strokeLinecap="square" strokeWidth="3">
        <path d="M162.1 79.1h54.2v46.4h-54.2z" />
        <path
          d="M202.3 66.3v12.8h-26.1V66.3a12.2 12.2 0 0 1 12.2-12.1h1.7a12.2 12.2 0 0 1 12.2 12.1z"
          fill="none"
        />
        <rect x="185.4" y="88" width="7.6" height="18.7" rx="2" ry="2" />
        <path d="M162.8 116.3h52.9" />
      </g>
      <path
        fill="#fff"
        d="M446.5 91.3c-36.2 0-66 29-66 65.3v54.2a24.4 24.4 0 0 0 24.4 24.4h82.4a24.4 24.4 0 0 0 24.4-24.4v-54.2a65 65 0 0 0-65.2-65.3z"
      />
      <path
        fill={theme.colors.accent}
        d="M487.3 236.6H405a25.8 25.8 0 0 1-25.8-25.8v-54.2A67.2 67.2 0 0 1 446.6 90a66.3 66.3 0 0 1 66.5 66.7v54.2a25.8 25.8 0 0 1-25.7 25.7zm-40.7-144a64.4 64.4 0 0 0-64.7 64v54.2a23 23 0 0 0 23.1 23h82.4a23 23 0 0 0 23-23v-54.2a63.5 63.5 0 0 0-63.8-64z"
      />
      <path
        fill="#fff"
        d="M485.6 259.2h-78.5c-29.2 1.8-52.4 27.4-52.4 59.3v.4h182v-.4c0-31.9-22-57.5-51-59.3z"
      />
      <path
        fill={theme.colors.accent}
        d="M536.7 319.8h-182v-.9h-.9v-1.5c.7-31.8 23.8-58 53.2-59.9h78.6a53.9 53.9 0 0 1 37.6 19 63.9 63.9 0 0 1 15 40.6v1.8h-1.7v1zm-180.2-2.7h179.3a61.6 61.6 0 0 0-14.5-39 50.9 50.9 0 0 0-35.7-18h-78.5c-28 1.7-50 26.7-50.6 57z"
      />
      <path fill="#fff" d="M426.3 230.8v28h.4l18.7 10.8 19.3-10.9V231z" />
      <path
        fill={theme.colors.accent}
        d="M445.4 271.2l-19.1-11h-1.4v-30.6H466v30l-20.7 11.6zm-17.8-13.5l18 10.4 17.8-10.1v-25.8h-35.8z"
      />
      <path fill="#fff" d="M491.4 197.6a46.2 46.2 0 0 1-92.3 0v-34.4a46.2 46.2 0 0 1 92.3 0z" />
      <path
        fill={theme.colors.accent}
        d="M445.7 244.7a47.6 47.6 0 0 1-47.5-47.5v-34.4a47.5 47.5 0 1 1 95 0v34.4a47.6 47.6 0 0 1-47.5 47.5zm0-126.7a44.9 44.9 0 0 0-44.8 44.8v34.4a44.8 44.8 0 0 0 89.6 0v-34.4a44.9 44.9 0 0 0-44.8-44.8z"
      />
      <path fill="#fff" d="M495 203h-3.7v-32.5h3.7c9 0 15.3 6.9 15.3 15.8s-6.2 16.8-15.3 16.8z" />
      <path
        fill={theme.colors.accent}
        d="M495 204h-4.6v-35.3h4.6c9.6 0 17.1 7.8 17.1 17.6S504.6 204 495 204zm-1.8-2.7h1.9c8 0 14.4-6.5 14.4-15s-6.4-14.9-14.4-14.9h-2z"
      />
      <path fill="#fff" d="M483.4 258.4l-21.5 60 39.7-30z" />
      <path
        fill={theme.colors.accent}
        d="M462 319.8a1.5 1.5 0 0 1-1-.3 1.4 1.4 0 0 1-.4-1.5l21.6-60a1.5 1.5 0 0 1 1.2-.9 1.4 1.4 0 0 1 1.2.6l18.2 30a1.4 1.4 0 0 1-.3 1.9l-39.7 30a1.3 1.3 0 0 1-.9.2zm21.7-58.2l-19 53 35-26.5-16-26.5z"
      />
      <path fill="#fff" d="M408.8 258.4l21.5 60-39.6-30z" />
      <path
        fill={theme.colors.accent}
        d="M430.3 319.8a1.5 1.5 0 0 1-.8-.3l-39.6-30a1.4 1.4 0 0 1-.4-1.8l18.2-30a1.3 1.3 0 0 1 1.3-.6 1.4 1.4 0 0 1 1.1 1l21.6 60a1.4 1.4 0 0 1-.5 1.4 4 4 0 0 1-.9.2zm-37.9-31.7l35 26.6-19-53-16 26.5z"
      />
      <path fill="#fff" d="M511.3 164.2v-7.6c0-36.3-28.4-64.9-64.7-64.9s-66.5 28.6-66.5 65v12" />
      <path
        fill={theme.colors.accent}
        d="M381.9 168.7h-2.7v-12A67.2 67.2 0 0 1 446.6 90a66.3 66.3 0 0 1 66.5 66.7v7.5h-2.7v-7.5a63.5 63.5 0 0 0-63.8-64 64.4 64.4 0 0 0-64.7 64v12z"
      />
      <path fill="#fff" d="M399.6 170c25.6.7 67.8-2.5 67.8-31.9 0 17 12.7 24.7 24.5 28" />
      <path
        fill={theme.colors.accent}
        d="M405.7 171.5l-6.2-.1v-2.7c16.5.4 46.2-.8 59.5-13.8 4.6-4.5 7-9.8 7-17h2.7c0 13.6 7.9 22.4 23.5 26.7l-.8 2.7c-12.9-3.6-21.1-10.6-24.1-20.3a25.2 25.2 0 0 1-6.5 10c-11.9 11.7-35.4 14.5-55 14.5z"
      />
      <path
        fill="#fff"
        d="M397.2 170.5c-9 0-17.2 6.9-17.2 15.8s8.2 16.8 17.2 16.8h1.8v-32.6zm1 30.7h-.9c-8.3 0-15.4-6.8-15.4-14.9s7-15 15.4-15h.9z"
      />
      <path
        fill={theme.colors.accent}
        d="M397.3 168.7c-9.8 0-18.1 8-18.1 17.6s8.3 17.7 18 17.7h3.7v-35.3zm.9 32.6h-1c-8.2 0-15.3-7-15.3-15s7-15 15.4-15h.9z"
      />
      <g fill="#fff" stroke={theme.colors.accent} strokeWidth="3">
        <path d="M390.8 170v34.3h-2a14.2 14.2 0 0 1-14-14.2V184a14.2 14.2 0 0 1 14-14.1z" />
        <path d="M399.2 169.2V205a4 4 0 0 1-1.2 2.8 6 6 0 0 1-4.3 1.7 5.8 5.8 0 0 1-5-2.5 3.8 3.8 0 0 1-.6-2v-35.8a3.6 3.6 0 0 1 .6-2 5.7 5.7 0 0 1 5-2.5 6.2 6.2 0 0 1 3.9 1.3 3.4 3.4 0 0 1 .4.4 4 4 0 0 1 1.2 2.8zm99.9.8v34.3h2a14.2 14.2 0 0 0 14.1-14.2V184a14.2 14.2 0 0 0-14-14.1z" />
        <path d="M490.8 169.2V205a4 4 0 0 0 1.2 2.8 6 6 0 0 0 4.3 1.7 5.8 5.8 0 0 0 5-2.5 3.8 3.8 0 0 0 .6-2v-35.8a3.6 3.6 0 0 0-.6-2 5.7 5.7 0 0 0-5-2.5 6.2 6.2 0 0 0-3.9 1.3 3.4 3.4 0 0 0-.4.4 4 4 0 0 0-1.2 2.8z" />
        <path d="M367.1 193.7v-47.3a77.1 77.1 0 0 1 77-77h3.3a77.1 77.1 0 0 1 76.9 77v47.3h-7.5v-46.6a69.8 69.8 0 0 0-69.6-69.5h-3a69.8 69.8 0 0 0-69.6 69.5v46.6z" />
        <path d="M410.5 230.6l-23-.8a12.7 12.7 0 0 1-12.7-12.6v-29.8" fill="none" />
        <rect x="398" y="225" width="28" height="11" rx="3" ry="3" />
      </g>
      <path
        fill="#fff"
        d="M287.7 362.5l-35.6-2.1a126 126 0 0 0-15 0l-36.6 2.1c-32 2-57.7 31-57.7 66.1v.5h201.4v-.5c.1-35-24.4-64-56.5-66z"
      />
      <path
        fill={theme.colors.accent}
        d="M344.3 430.1H143v-1h-1v-1.7c.7-35.1 26.3-64.2 59-66.2l36.1-2.1a129.3 129.3 0 0 1 15.3 0l35.6 2.1c32.3 2 57.6 30.9 58.3 66.2v2h-2v.8zm-199.4-3h198.4c-.7-33.7-24.8-61.2-55.4-63l-35.7-2.3a124.3 124.3 0 0 0-15 0l-36.1 2.2c-31 1.9-55.5 29.5-56.2 63.1z"
      />
      <path fill="#fff" d="M284.8 362.5h-81.5l10 66.1h61.5z" />
      <path
        fill={theme.colors.accent}
        d="M274.8 430.2h-61.5a1.6 1.6 0 0 1-1.6-1.4l-10-66a1.6 1.6 0 0 1 .4-1.4 1.4 1.4 0 0 1 1.2-.5h81.4a1.4 1.4 0 0 1 1.2.5 2 2 0 0 1 .4 1.3l-10 66.1a1.5 1.5 0 0 1-1.5 1.4zm-60.1-3.1h58.7l9.5-63h-77.7z"
      />
      <path fill="#fff" d="M260.2 428.6H229l7-49.3h17.3z" />
      <path
        fill={theme.colors.accent}
        d="M262 430.1h-34.7l7.3-52.3h20zm-31.3-3h27.8l-6.6-46.3h-14.7z"
      />
      <path fill="#fff" d="M264.6 363.3a21 21 0 0 1-42 0v-32.9a21 21 0 0 1 42 0z" />
      <path
        fill={theme.colors.accent}
        d="M244.1 385.3a22.5 22.5 0 0 1-22.4-22.5V330a22.4 22.4 0 0 1 44.9 0v33a22.5 22.5 0 0 1-22.5 22.4zm0-74.8a19.4 19.4 0 0 0-19.4 19.4v33a19.4 19.4 0 0 0 38.9 0v-33a19.5 19.5 0 0 0-19.5-19.4z"
      />
      <path
        fill="#fff"
        d="M299.3 299.5h-4.8v-35.9h4.8c9.8 0 17.1 5.6 17.1 15.5v2c0 10-7.3 18.4-17.1 18.4z"
      />
      <path
        fill={theme.colors.accent}
        d="M299.3 300.5h-5.8v-38.9h5.8c11.2 0 19 7.2 19 17.5v2a19 19 0 0 1-19 19.4zm-2.8-3h2.7a16 16 0 0 0 16.2-16.4v-2c0-8.7-6.5-14.5-16.1-14.5h-2.8z"
      />
      <path
        fill="#fff"
        d="M190.5 299.5h2.3v-35.9h-2.3c-9.9 0-18.7 7.6-18.7 17.5s8.7 18.4 18.7 18.4z"
      />
      <path
        fill={theme.colors.accent}
        d="M194.8 300.5h-4.3a19.4 19.4 0 1 1 0-38.9h4.3zm-21-19.4a16.6 16.6 0 0 0 16.7 16.4h1.3v-32.9h-1.3a16.6 16.6 0 0 0-16.7 16.5z"
      />
      <path
        fill="#fff"
        d="M255 339.8h-21.8a39.9 39.9 0 0 1-40-39.9v-82.4H295v82.4a40 40 0 0 1-39.9 40z"
      />
      <path
        fill={theme.colors.accent}
        d="M255 341.3h-21.8a41.4 41.4 0 0 1-41.4-41.4V216h104.7v84a41.5 41.5 0 0 1-41.4 41.4zM194.9 219v81a38.5 38.5 0 0 0 38.3 38.4h22a38.5 38.5 0 0 0 38.4-38.4v-81z"
      />
      <path fill="#fff" d="M226.4 385.8l-25-23.4 17.5-18.8L244 367z" />
      <path
        fill={theme.colors.accent}
        d="M226.4 387.3a1.3 1.3 0 0 1-1-.4l-25.2-23.5a1.4 1.4 0 0 1-.4-1 1.5 1.5 0 0 1 .3-1l17.6-18.9a1.5 1.5 0 0 1 2-.1l25.2 23.4a1.4 1.4 0 0 1 .5 1 1.5 1.5 0 0 1-.4 1.1l-17.5 18.9a1.3 1.3 0 0 1-1.1.5zm-23-25l23 21.4 15.5-16.7-22.9-21.3z"
      />
      <path fill="#fff" d="M244 367l25.1-23.4 17.6 18.8-25.1 23.4z" />
      <path
        fill={theme.colors.accent}
        d="M261.6 387.3a1.6 1.6 0 0 1-1.1-.5l-17.6-18.9a1.5 1.5 0 0 1-.4-1 1.2 1.2 0 0 1 .5-1l25.1-23.4a1.4 1.4 0 0 1 2.1.1l17.6 18.8a1.5 1.5 0 0 1 .4 1.1 1.2 1.2 0 0 1-.5 1L262.6 387a1.7 1.7 0 0 1-1 .3zM246 367l15.6 16.6 22.9-21.3-15.6-16.6z"
      />
      <path
        fill="#fff"
        d="M298.4 213.2a33.6 33.6 0 0 0 5.1-18v-12.3H222a32.3 32.3 0 0 0-32.2 30.3 19.9 19.9 0 0 0-9.3 16.8v34.1h11.8a20 20 0 0 0 20-20v-15h57.2a29.7 29.7 0 0 0 6.7-.6v15.7a20 20 0 0 0 20 20h11.7V230a19.8 19.8 0 0 0-9.4-16.8z"
      />
      <path
        fill={theme.colors.accent}
        d="M309.3 265.6h-13.2a21.4 21.4 0 0 1-21.5-21.4v-13.9a30.3 30.3 0 0 1-5.2.4h-55.8v13.5a21.4 21.4 0 0 1-21.4 21.4h-13.3V230a21.5 21.5 0 0 1 9.4-17.8 33.8 33.8 0 0 1 33.6-31H305V195a36 36 0 0 1-4.6 17.6 21.4 21.4 0 0 1 9 17.3v35.7z"
      />
      <path
        fill="#fff"
        d="M277.5 226.8v17.4a18.5 18.5 0 0 0 18.5 18.4h10.3V230a18.4 18.4 0 0 0-8.8-15.7l-1.3-.8.8-1.2a33 33 0 0 0 4.8-17.3v-10.7h-80.1a30.8 30.8 0 0 0-30.7 28.9v.8l-.7.4a18.4 18.4 0 0 0-8.6 15.5v32.6H192a18.5 18.5 0 0 0 18.4-18.4v-16.5h58.9a34.4 34.4 0 0 0 6.3-.6l2-.3z"
      />
      <g fill="#fff" stroke={theme.colors.accent} strokeWidth="3">
        <path d="M183.6 260.4V299h-2.2a15.8 15.8 0 0 1-15.8-15.8v-6.9a15.8 15.8 0 0 1 15.8-15.8z" />
        <path d="M192.9 259.6v40a4.4 4.4 0 0 1-1.4 3.2 6.7 6.7 0 0 1-4.8 2 6.4 6.4 0 0 1-5.6-3 4.3 4.3 0 0 1-.6-2.1v-40.1a4.1 4.1 0 0 1 .6-2.2 6.4 6.4 0 0 1 5.6-2.8 7 7 0 0 1 4.4 1.4 4.2 4.2 0 0 1 .4.5 4.4 4.4 0 0 1 1.4 3zm111.7.8V299h2.2a15.8 15.8 0 0 0 15.8-15.8v-6.9a15.8 15.8 0 0 0-15.8-15.8z" />
        <path d="M295.3 259.6v40a4.4 4.4 0 0 0 1.4 3.2 6.7 6.7 0 0 0 4.8 2 6.4 6.4 0 0 0 5.6-3 4.2 4.2 0 0 0 .6-2.1v-40.1a4.1 4.1 0 0 0-.6-2.2 6.4 6.4 0 0 0-5.6-2.8 7 7 0 0 0-4.4 1.4 4.2 4.2 0 0 0-.4.5 4.4 4.4 0 0 0-1.4 3z" />
        <path d="M157 287v-52.9a86.3 86.3 0 0 1 86-86h3.8a86.3 86.3 0 0 1 86 86v53h-8.4V235a78 78 0 0 0-77.8-77.8h-3.4a78 78 0 0 0-77.8 77.8v52.1z" />
        <path d="M205.6 328.2l-25.7-.8a14.2 14.2 0 0 1-14.2-14.1V280" fill="none" />
        <rect x="190.3" y="322" width="37.4" height="10.6" rx="3" ry="3" />
      </g>
      <path
        fill={theme.colors.accent}
        d="M309.3 265.7h-13.2a21.4 21.4 0 0 1-21.5-21.4v-14a30.3 30.3 0 0 1-5.2.5h-55.8v13.4a21.4 21.4 0 0 1-21.4 21.5h-13.3V230a21.5 21.5 0 0 1 9.4-17.8 33.8 33.8 0 0 1 33.6-31H305V195a36 36 0 0 1-4.6 17.6 21.4 21.4 0 0 1 9 17.3v35.7z"
      />
      <path
        fill="#fff"
        d="M277.5 226.8v17.4a18.5 18.5 0 0 0 18.5 18.5h10.3V230a18.4 18.4 0 0 0-8.8-15.7l-1.3-.8.8-1.3a33 33 0 0 0 4.9-17.2v-10.8h-80.2a30.8 30.8 0 0 0-30.7 29v.7l-.7.4a18.4 18.4 0 0 0-8.6 15.6v32.6H192a18.5 18.5 0 0 0 18.4-18.4v-16.5h58.9a34.4 34.4 0 0 0 6.3-.6l2-.3zM521 94.5h22.1V113l18.3-18.4h63.9V12.1H521z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M542 95.3h-22.6V10.5h106.7v84.8H562l-20.1 20.2zM623.7 13H521.8v80h22.6v16.6L561 93h62.7z"
      />
      <path fill="#fff" d="M146 230.2h-32l.1 25.4-25.3-25.4H1.6V116.1h144.5z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M88.3 231H0V114.4h147v116.8h-31.7l.2 27.2zm56-114H2.5v111.5h86.8l23.5 23.5-.1-23.5h31.6z"
      />
      <g fill="#c2d2da">
        <circle cx="594" cy="52" r="6" />
        <circle cx="573" cy="52" r="6" />
        <circle cx="551" cy="52" r="6" />
        <circle cx="71" cy="170" r="26.6" />
      </g>
      <path
        d="M65.8 160.3a6.8 6.8 0 0 1 5.2-2 7 7 0 0 1 4.8 1.8 5.7 5.7 0 0 1 1.9 4.4 4.8 4.8 0 0 1-.7 2.6 20.7 20.7 0 0 1-2.7 2.9 6 6 0 0 0-2.3 5.3h-2.7a10.4 10.4 0 0 1 .5-3.5 8.4 8.4 0 0 1 2.3-3l1.2-1.3a4.6 4.6 0 0 0 .9-1 3.8 3.8 0 0 0 .6-2 4.7 4.7 0 0 0-.9-2.6 3.9 3.9 0 0 0-3-1.2 3.5 3.5 0 0 0-3.5 2 6.8 6.8 0 0 0-.6 3H64a7.1 7.1 0 0 1 1.7-5.3zm3.4 17.5h3v3.2h-3z"
        fill="#dee9ef"
      />
    </SvgIcon>
  );
};

export default IconOnlineMeetings;
